// extracted by mini-css-extract-plugin
export default {"amlPopup":"AMLPopup_amlPopup__zfvT6","title":"AMLPopup_title__A2n6q"};